export const LOG_MODULE_KEY = '[LOCALIZATION]'
